import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { fetchPaymentSchedule } from "redux/features/payment_schedule/paymentScheduleThunk"
import { fetchPaymentScheduleAttachment } from "redux/features/payment_schedule/paymentScheduleDownloadThunk"
import { PaymentScheduleType } from "types"

const paymentScheduleAdapter = createEntityAdapter({
  selectId: (payment_schedule: PaymentScheduleType) => payment_schedule.id,
})

export const initialState = paymentScheduleAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const paymentScheduleSlice = createSlice({
  name: "payment-schedule",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPaymentSchedule.pending, (state) =>
        handleFetchPending(state),
      )
      .addCase(fetchPaymentSchedule.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(fetchPaymentSchedule.fulfilled, (state, { payload }) => {
        paymentScheduleAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
      .addCase(fetchPaymentScheduleAttachment.pending, (state) =>
        handleFetchPending(state),
      )
      .addCase(fetchPaymentScheduleAttachment.rejected, (state) =>
        handleFetchRejected(state),
      )
      .addCase(fetchPaymentScheduleAttachment.fulfilled, (state) =>
        handleFetchFulfilled(state),
      )
  },
})

export const { selectById: selectPaymentScheduleById } =
  paymentScheduleAdapter.getSelectors(
    (state: RootState) => state.features.payment_schedule,
  )
export const selectFetchStatus = (state: RootState) =>
  state.features.payment_schedule.fetchStatus

export default paymentScheduleSlice.reducer
